/**
 * Parses SolveTax locale XML: <resources><string name="id">text</string>...</resources>
 */
export function parseLocaleXml(xmlText) {
  const doc = new DOMParser().parseFromString(xmlText, 'application/xml');
  const err = doc.querySelector('parsererror');
  if (err) {
    // eslint-disable-next-line no-console
    console.error('[i18n] XML parse error', err.textContent);
    return {};
  }
  const map = {};
  doc.querySelectorAll('resources > string').forEach((el) => {
    const name = el.getAttribute('name');
    if (name) map[name] = (el.textContent || '').replace(/\s+/g, ' ').trim();
  });
  return map;
}
